import { Pipe, PipeTransform } from '@angular/core';

/**
 * 將YYYYMMDD格式的日期轉換為YYY.MM.DD格式的管道
 * ex. 20250101 轉換為 114.01.01
 */
@Pipe({
  name: 'twDate',
  standalone: true,
})
export class TwDatePipe implements PipeTransform {
  transform(value: string): string {
    if (value && /^\d{8}$/.test(value)) {
      const year = Number(value.substring(0, 4)) - 1911;
      const month = value.substring(4, 6);
      const day = value.substring(6, 8);
      return `${year}.${month}.${day}`;
    }
    return value;
  }
}
